import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'

const feeApi = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    fetchAccount: {
      balance: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/account/balance`,
          method: 'post',
        })
      },
    },
  }
}

export default feeApi
